export const translations = {
	'Warm start': {
		no: 'Varmstart',
	},
	'Cold start': {
		no: 'Kaldstart',
	},
	'Run script': {
		no: 'Kjør skript',
	},
	'Install bundles': {
		no: 'Installer pakker',
	},
	'Uninstall bundles': {
		no: 'Avinstaller pakker',
	},
	'Bundles will be installed for: ': {
		no: 'Pakkene vil bli lastet opp på: ',
	},
	'Please, input the name of agent.': {
		no: 'Skriv inn navn på agent',
	},
	'Agent successfully updated': {
		no: 'Agent er oppdatert',
	},
	'Select protocol...': {
		no: 'Velg protokoll',
	},
	'Agent successfully created': {
		no: 'Agent er opprettet',
	},
	'Thread': {
		no: 'Tråd',
	},
	'Logger': {
		no: 'Kilde',
	},
	'Log level': {
		no: 'Loggnivå',
	},
	'Setup successfully saved': {
		no: 'Konfigurasjon er lagret',
	},
	'This will revert all log configuration settings for agent': {
		no: 'Dette vil tilbakestille konfigurasjon for agent',
	},
	'Log configuration reset to default settings': {
		no: 'Logg konfigurajon er tilbakestilt til standard instilling',
	},
	'Delete invalid message': {
		no: 'Slett ugyldig melding',
	},
	'View message': {
		no: 'Se melding',
	},
	'Start message queue': {
		no: 'Start meldingskø',
	},
	'Clear message queue': {
		no: 'Slett meldingskø',
	},
	'First message in selected message queue is removed': {
		no: 'Første melding er slettet i valgt meldingskø',
	},
	'View message commmand sent to message queue': {
		no: 'Se melding kommando sent til meldingskø',
	},
	'No data in message queue': {
		no: 'Ingen data i meldingskø',
	},
	'Start command sent to message queue': {
		no: 'Start kommando sendt til meldingskø',
	},
	'Clear command sent to messages queue': {
		no: 'Nullstill kommando sendt til meldingskø',
	},
	'Last connected': {
		no: 'Sist tilkoblet',
	},
	'Allow subagent': {
		no: 'Tillat underagent',
	},
	'Allow data collection': {
		no: 'Tillat datainnsamling',
	},
	'Shared agent': {
		no: 'Delte agenter',
	},
	'Agent version': {
		no: 'Agentversjon',
	},
	'Agent successfully deleted': {
		no: 'Agent er slettet',
	},
	'Connect new agent': {
		no: 'Tilkoble ny agent',
	},
	'Initiate agent': {
		no: 'Initier agent',
	},
	'Remove agent ${name} from following places before deleting agent': {
		no: 'Agent ${name} må fjernes fra følgende elementer før den kan slettes',
	},
	'Errorcode': {
		no: 'Feilkode',
	},
	'Stack trace': {
		no: 'Stack Trace',
	},
	'Show all': {
		no: 'Vis alle',
	},
	'Show not acknowledge': {
		no: 'Ikke vis bekreftede',
	},
	'Are you sure you want to remove system messages?': {
		no: 'Vil du slette systemmeldingene?',
	},
	'Are you sure you want to remove system message?': {
		no: ' Vil du slette systemmelding?',
	},
	'System messages deleted.': {
		no: 'Systemmeldingene er slettet.',
	},
	'Warnings': {
		no: 'Advarsel',
	},
	'No items to display': {
		no: 'Ingen elementer å vise',
	},
	'Agent configuration was successfully updated': {
		no: 'Agent konfigurasjon oppdatert',
	},
	'Install module': {
		no: 'Installer modul',
	},
	'Uninstall module': {
		no: 'Avinstaller modul',
	},
	'Module successfully installed': {
		no: 'Komponent er installert',
	},
	'Failed to install module': {
		no: 'Komponent ble ikke installert',
	},
	'Module uninstalled': {
		no: 'Komponent er avinstallert',
	},
	'Failed to uninstall module': {
		no: 'Komponent ble ikke avinstallert',
	},
	'Upload': {
		no: 'Last opp',
	},
	'Only the files with the extension .jar are allowed': {
		no: 'Bare filer med filtype .jar er tillatt',
	},
	'Bundles were successfully uploaded': {
		no: 'Pakkene ble lastet opp',
	},
	'Unable to upload bundles': {
		no: 'Klarte ikke laste opp pakker',
	},
	'Bundles were successfully deleted': {
		no: 'Pakker ble slettet',
	},
	'The following bundles could not be deleted: ': {
		no: 'Pakker ble ikke slettet: ',
	},
	'Last command': {
		no: 'Siste kommando',
	},
	'Last login': {
		no: 'Siste innlogging',
	},
	'This is a generic public users and has no significant details.': {
		no: 'Dette er en felles åpen bruker og har ingen detaljer.',
	},
	'The grid has been reloaded': {
		no: 'Tabellen er lastet på nytt',
	},
};
